module.exports = __webpack_public_path__ + "static/media/vectorAcert.2a71f20a.svg";